/**
 * getValue retrieves a value from an object, or returns a default value if it does not exist.
 *
 * @param object the object to retrieve the value from
 * @param path either a string or array of instructions on how to traverse the object structure
 * @param defaultValue value returned if the value is null or undefined within the object.
 */
export const getValue = <T = unknown>(
  object: Record<string, unknown>,
  path: RegExp | string | string[],
  defaultValue?: T
): T | undefined => {
  let value: unknown;

  if (typeof object === "object" && (typeof path === "string" || Array.isArray(path))) {
    const paths: string[] = String.prototype.split.call(path, /[,[\].]+/).filter(Boolean);

    value = paths.reduce((currentValue: any, key: string) => currentValue?.[key], object);
  }

  return (value ?? defaultValue) as T | undefined;
};
